import { useApolloClient } from '@apollo/client'
import { useEffectReducer } from 'use-effect-reducer'
import { TAG, useTrackLSPAYError } from '../errorTracking'
import { useTrackLSPAYTiming } from '../timeTracking'
import { useShouldUseSimulator } from '../useShouldUseSimulator'
import { useVdFeatureManager } from '../../../../../ng-compat/hooks'
import { SANDBOX_FLAG } from '../../helpers/lspayConstants'
import { getRefundEffectsMap } from './effects'
import { refundStateReducer } from './reducer'
import { RefundReducerArgs, RefundState } from './types'

export const useRefundEffectReducer = (args: RefundReducerArgs) => {
  const {
    retailerPaymentType,
    transactionId,
    amount,
    originalRegisterSalePaymentId,
  } = args

  const trackError = useTrackLSPAYError(TAG.refund, {
    transactionId,
    originalRegisterSalePaymentIds: [originalRegisterSalePaymentId],
  })
  const trackTiming = useTrackLSPAYTiming({
    transactionId,
    paymentTypeId: retailerPaymentType.type_id,
    isRefund: amount.isNegative(),
  })
  const shouldUseSimulator = useShouldUseSimulator()
  const isSandbox = useVdFeatureManager().get(SANDBOX_FLAG)

  const apolloClient = useApolloClient()

  const effectReducer = useEffectReducer(
    refundStateReducer,
    // initial state
    exec => {
      exec({
        type: 'cardNotPresentEffect',
      })
      return {
        status: 'refundingViaCardNotPresent',
        errorMessage: undefined,
        retailerPaymentType,
        retryable: false,
      } as RefundState
    },
    getRefundEffectsMap({
      ...args,
      trackError,
      trackTiming,
      isSimulated: shouldUseSimulator,
      apolloClient,
      isSandbox,
    })
  )

  return effectReducer
}
